<app-offcanvas-sheet
  [visible]="visible"
  [title]="editData.itemName ? editData.itemName : 'Add Item'"
  (closeCanvas)="onClose()"
  (save)="onSave()">

  <span sheetHeaderExtra class="sheet-category-badge">{{ editData.category }}</span>

  <!-- Item name (editable for new items, hidden for labour/FOH since Activity/dropdown serves this purpose) -->
  <div class="form-group-mobile" *ngIf="!isDirectLabour && !isIndirectLabour && !isVariableOverhead && !isCompetitor && !isProduct && !isFixedOverhead">
    <label>Item Name</label>
    <!-- Full plan: pick from inventory raw materials -->
    <app-single-select-dropdown
      *ngIf="isMaterial && accountType !== 'calculator'; else materialNameInput"
      [options]="materialOptions"
      [selectedValue]="editData.inventoryId ? String(editData.inventoryId) : null"
      placeholder="Select material"
      (selectedValueChange)="onMaterialNameChange($event)">
    </app-single-select-dropdown>
    <!-- Calculator-only plan (and any other category): free-text name -->
    <ng-template #materialNameInput>
      <input
        type="text"
        class="form-control form-control-sm"
        [(ngModel)]="editData.itemName"
        placeholder="Enter item name"
      />
    </ng-template>
  </div>

  <!-- Product fields -->
  <ng-container *ngIf="isProduct">
    <div class="form-group-mobile">
      <label>Product Name</label>
      <input
        type="text"
        class="form-control form-control-sm"
        [(ngModel)]="editData.itemName"
        placeholder="Enter product name"
      />
    </div>
    <div class="form-group-mobile">
      <label>Selling Price (ZAR)</label>
      <input
        type="text"
        inputmode="decimal"
        class="form-control form-control-sm"
        [(ngModel)]="editData.sellingPrice"
      />
    </div>

  </ng-container>

  <!-- Material-specific fields -->
  <ng-container *ngIf="isMaterial">
    <div class="form-group-mobile">
      <label>Purchase Price</label>
      <input
        type="text"
        inputmode="decimal"
        class="form-control"
        [(ngModel)]="editData.purchasePrice"
        (ngModelChange)="onMaterialInputChange()"
      />
    </div>
    <div class="form-group-mobile">
      <label>Purchase Quantity</label>
      <input
        type="text"
        inputmode="decimal"
        class="form-control"
        [(ngModel)]="editData.purchaseQuantity"
        (ngModelChange)="onMaterialInputChange()"
      />
    </div>
    <div class="form-group-mobile">
      <label>Purchase Unit</label>
      <app-single-select-dropdown
        [options]="uomOptions"
        [selectedValue]="editData.purchaseUnit || null"
        placeholder="Select unit"
        (selectedValueChange)="onPurchaseUnitChange($event)">
      </app-single-select-dropdown>
    </div>
    <div class="form-group-mobile">
      <label>Usage Quantity</label>
      <input
        type="text"
        inputmode="decimal"
        class="form-control"
        [(ngModel)]="editData.usageQuantity"
        (ngModelChange)="onMaterialInputChange()"
      />
    </div>
    <div class="form-group-mobile">
      <label>Usage Unit</label>
      <app-single-select-dropdown
        [options]="uomOptions"
        [selectedValue]="editData.usageUnit || null"
        placeholder="Select unit"
        (selectedValueChange)="onUsageUnitChange($event)">
      </app-single-select-dropdown>
    </div>
    <div class="form-group-mobile">
      <label>Batch Size</label>
      <input
        type="text"
        inputmode="decimal"
        class="form-control"
        [(ngModel)]="editData.batchSize"
        (ngModelChange)="onMaterialInputChange()"
      />
    </div>
  </ng-container>

  <!-- Direct/Indirect Labour fields -->
  <ng-container *ngIf="isDirectLabour || isIndirectLabour">
    <div class="form-group-mobile">
      <label>Employee</label>
      <app-single-select-dropdown
        [options]="employeeOptions"
        [selectedValue]="editData.employeeID != null ? String(editData.employeeID) : null"
        placeholder="Select employee"
        (selectedValueChange)="onEmployeeChange($event)">
      </app-single-select-dropdown>
    </div>
    <div class="form-group-mobile">
      <label>Role</label>
      <input
        type="text"
        class="form-control"
        [value]="editData.roleDescription || ''"
        readonly
      />
    </div>
    <div class="form-group-mobile">
      <label>Monthly Salary (ZAR)</label>
      <input
        type="text"
        inputmode="decimal"
        class="form-control"
        [(ngModel)]="editData.monthlySalary"
        readonly
      />
    </div>
    <div class="form-group-mobile">
      <label>Hours Worked / Month</label>
      <input
        type="text"
        inputmode="decimal"
        class="form-control"
        [(ngModel)]="editData.hoursWorkedPm"
        readonly
      />
    </div>
    <div class="form-group-mobile">
      <label>Rate Type</label>
      <input
        type="text"
        class="form-control"
        [value]="editData.rateType ?? 'Per Minute'"
        readonly
      />
    </div>
    <div class="form-group-mobile">
      <label>Rate / Min (ZAR)</label>
      <input
        type="text"
        inputmode="decimal"
        class="form-control"
        [value]="(editData.hoursWorkedPm ?? 0) > 0 ? ((editData.monthlySalary ?? 0) / ((editData.hoursWorkedPm ?? 0) * 60)).toFixed(4) : '0.0000'"
        readonly
      />
    </div>
    <div class="form-group-mobile">
      <label>Activity</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="editData.itemName"
        placeholder="Enter activity"
      />
    </div>
    <div class="form-group-mobile">
      <label>{{ isIndirectLabour ? 'Minutes per Activity' : 'Minutes per Job' }}</label>
      <input
        *ngIf="isIndirectLabour"
        type="text"
        inputmode="decimal"
        class="form-control"
        [(ngModel)]="editData.minutesPerActivity"
        (ngModelChange)="recalculateDerivedFields()"
      />
      <input
        *ngIf="!isIndirectLabour"
        type="text"
        inputmode="decimal"
        class="form-control"
        [(ngModel)]="editData.minutesPerJob"
        (ngModelChange)="recalculateDerivedFields()"
      />
    </div>
    <div class="form-group-mobile">
      <label>Batch Size</label>
      <input
        type="text"
        inputmode="decimal"
        class="form-control"
        [(ngModel)]="editData.batchSize"
        (ngModelChange)="recalculateDerivedFields()"
      />
    </div>
  </ng-container>

  <!-- Fixed overhead fields -->
  <ng-container *ngIf="isFixedOverhead">
    <div class="form-group-mobile">
      <label>FOH Name</label>
      <app-single-select-dropdown
        [options]="fixedOverheadOptions"
        [selectedValue]="editData.overheadCostItemID != null ? String(editData.overheadCostItemID) : null"
        placeholder="Select overhead"
        (selectedValueChange)="onFixedOverheadChange($event)">
      </app-single-select-dropdown>
    </div>
    <div class="form-group-mobile">
      <label>Cost per Month (ZAR)</label>
      <input
        type="text"
        inputmode="decimal"
        class="form-control"
        [(ngModel)]="editData.costPerMonth"
        readonly
      />
    </div>
    <div class="form-group-mobile">
      <label>Hours Open / Month</label>
      <input
        type="text"
        inputmode="decimal"
        class="form-control"
        [(ngModel)]="editData.hoursOpenPerMonth"
        readonly
      />
    </div>
    <div class="form-group-mobile">
      <label>Rate / Min (ZAR)</label>
      <input
        type="text"
        inputmode="decimal"
        class="form-control"
        [value]="(editData.hoursOpenPerMonth ?? 0) > 0 ? ((editData.costPerMonth ?? 0) / ((editData.hoursOpenPerMonth ?? 0) * 60)).toFixed(4) : '0.0000'"
        readonly
      />
    </div>
    <div class="form-group-mobile">
      <label>Min / Batch</label>
      <input
        type="text"
        inputmode="decimal"
        class="form-control"
        [(ngModel)]="editData.minutesPerOrder"
        (ngModelChange)="recalculateDerivedFields()"
      />
    </div>
    <div class="form-group-mobile">
      <label>Batch Size</label>
      <input
        type="text"
        inputmode="decimal"
        class="form-control"
        [(ngModel)]="editData.batchSize"
        (ngModelChange)="recalculateDerivedFields()"
      />
    </div>
  </ng-container>

  <!-- Variable overhead fields -->
  <ng-container *ngIf="isVariableOverhead">
    <div class="form-group-mobile">
      <label>VOH Name</label>
      <app-single-select-dropdown
        [options]="variableOverheadOptions"
        [selectedValue]="editData.inventoryId != null ? String(editData.inventoryId) : null"
        placeholder="Select variable overhead"
        (selectedValueChange)="onVariableOverheadChange($event)">
      </app-single-select-dropdown>
    </div>
    <div class="form-group-mobile">
      <label>Purchase Price</label>
      <input
        type="text"
        inputmode="decimal"
        class="form-control"
        [(ngModel)]="editData.purchasePrice"
        readonly
      />
    </div>
    <div class="form-group-mobile">
      <label>Purchase Quantity</label>
      <input
        type="text"
        inputmode="decimal"
        class="form-control"
        [(ngModel)]="editData.purchaseQuantity"
        readonly
      />
    </div>
    <div class="form-group-mobile">
      <label>Price / Unit</label>
      <input
        type="text"
        inputmode="decimal"
        class="form-control"
        [(ngModel)]="editData.purchasePricePerUnit"
        readonly
      />
    </div>
    <div class="form-group-mobile">
      <label>Usage Quantity</label>
      <input
        type="text"
        inputmode="decimal"
        class="form-control"
        [(ngModel)]="editData.usageQuantity"
        (ngModelChange)="recalculateDerivedFields()"
      />
    </div>
    <div class="form-group-mobile">
      <label>Batch Size</label>
      <input
        type="text"
        inputmode="decimal"
        class="form-control"
        [(ngModel)]="editData.batchSize"
        (ngModelChange)="recalculateDerivedFields()"
      />
    </div>
  </ng-container>
  <!-- Competitor fields -->
  <ng-container *ngIf="isCompetitor">
    <div class="form-group-mobile" *ngIf="!editData.isTargetSellingPrice">
      <label>Competitor Name</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="editData.itemName"
        placeholder="Enter competitor name"
      />
    </div>
    <div class="form-group-mobile" *ngIf="editData.isTargetSellingPrice">
      <label>Label</label>
      <input type="text" class="form-control" value="Your Target Selling Price" readonly />
    </div>
    <div class="form-group-mobile">
      <label>Price (ZAR)</label>
      <input
        type="text"
        inputmode="decimal"
        class="form-control"
        [(ngModel)]="editData.price"
      />
    </div>
    <div class="form-group-mobile">
      <label>Website</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="editData.website"
        placeholder="https://"
      />
    </div>
    <div class="form-group-mobile">
      <label>Active</label>
      <div class="form-check form-switch mt-1">
        <input
          class="form-check-input"
          type="checkbox"
          role="switch"
          id="competitorIsActiveSwitch"
          [(ngModel)]="editData.isActive"
        />
        <label class="form-check-label" for="competitorIsActiveSwitch" style="padding-left: 1rem;">{{ editData.isActive ? 'Active' : 'Inactive' }}</label>
      </div>
    </div>
    <div class="form-group-mobile">
      <label>Target Market Segment</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="editData.targetMarketSegment"
        placeholder="e.g. SME, Enterprise"
      />
    </div>
    <div class="form-group-mobile">
      <label>Primary Sales Channel</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="editData.primarySalesChannel"
        placeholder="e.g. Online, Retail"
      />
    </div>
    <div class="form-group-mobile">
      <label>Geographic Focus</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="editData.geographicFocus"
        placeholder="e.g. National, Western Cape"
      />
    </div>
  </ng-container>

  <!-- Unit Cost — last field for all cost categories except Product/Competitor -->
  <div class="form-group-mobile" *ngIf="!isProduct && !isCompetitor">
    <label>Unit Cost (ZAR)</label>
    <input
      type="text"
      inputmode="decimal"
      class="form-control"
      [(ngModel)]="editData.unitCost"
      [readonly]="isMaterial || isDirectLabour || isIndirectLabour || isFixedOverhead || isVariableOverhead"
    />
  </div>

</app-offcanvas-sheet>
